import { RefObject, useCallback } from 'react'
import css from './useNodeOutline.module.css'

const useNodeOutline = (imageContainer: RefObject<HTMLDivElement>) => {
  return useCallback((id: string) => {
    let rect = document.getElementById('svg_diagram_outline') as HTMLDivElement
    const e: SVGElement = imageContainer.current.querySelector('#' + id)

    if (!e) {
      if (rect) rect.remove()
      return
    }

    if (!rect) {
      rect = document.createElement('div')
      rect.setAttribute('id', 'svg_diagram_outline')
    }

    const box = e.getBoundingClientRect()
    const containerBox = imageContainer.current.getBoundingClientRect()
    const x = Math.round(box.left - containerBox.left)
    const y = Math.round(box.top - containerBox.top)

    // начать css анимацию заново
    rect.classList.remove(css.outline)
    rect.classList.add(css.outline)

    rect.style.width = Math.round(box.width) + 'px'
    rect.style.height = Math.round(box.height) + 'px'
    rect.style.top = y + 'px'
    rect.style.left = x + 'px'

    imageContainer.current.appendChild(rect)
  }, [])
}

export default useNodeOutline
